import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { UNREAD_CONVERSATIONS_QUERY_KEY } from '../../queries/useUnreadConversationsCount'

const markConversationRead = async (conversationId: string): Promise<void> => {
  await api.put(`/conversations/${conversationId}/read`)
}

/**
 * Marks a conversation as read (records "now" as last-read server-side), then
 * refreshes the conversation list and the unread badge.
 */
export const useMarkConversationRead = () => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, string>({
    mutationFn: markConversationRead,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['conversations'] }),
        queryClient.invalidateQueries({ queryKey: UNREAD_CONVERSATIONS_QUERY_KEY }),
      ])
    },
  })
}
